// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__5PCek","imageContainer":"styles_imageContainer__giVF8","tagsContainer":"styles_tagsContainer__xSE0K"};